/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Document_UploadedInputs */

const cs_enum_document_uploaded = /** @type {(inputs: Enum_Document_UploadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokument nahrán`)
};

const en_enum_document_uploaded = /** @type {(inputs: Enum_Document_UploadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document uploaded`)
};

/**
* | output |
* | --- |
* | "Document uploaded" |
*
* @param {Enum_Document_UploadedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_document_uploaded = /** @type {((inputs?: Enum_Document_UploadedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Document_UploadedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_document_uploaded(inputs)
	return cs_enum_document_uploaded(inputs)
});